import React, { FC } from 'react';
import { Link } from 'react-router-dom';
const PageNotFound: FC = () => {
  return (
    <div className="flex flex-col my-auto flex-auto h-full">
      <div className="flex flex-col flex-auto items-center justify-center h-auto  my-auto p-6 sm:p-10">
        <div className="w-full h-auto max-w-lg">
          <img src={'../assets/images/pageNotFound.svg'} alt="page not found" />
        </div>
        <div className="mt-12 sm:mt-24 text-4xl md:text-7xl font-extrabold tracking-tight leading-tight md:leading-none text-center">
          Ooops... 404!
        </div>
        <div className="mt-2 text-lg md:text-xl font-medium tracking-tight text-center text-gray-600">
          The page you requested could not be found.
        </div>
        <Link className="mt-12 font-medium underline text-primary" to="/">
          {' '}
          Back to Home{' '}
        </Link>{' '}
      </div>
    </div>
  );
};

export default PageNotFound;
